class StickyProductBar extends HTMLElement {
  constructor() {
    super();
    this.isVisible = false;
    this.triggerElement = null;
    this.init();
  }

  connectedCallback() {
    this.setupScrollListener();
    document.body.appendChild(this);
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  init() {
    // Find the trigger element (original add to cart button)
    this.triggerElement = document.querySelector(
      ".product__section--buttons-outer"
    );

    // Set initial visibility
    this.style.display = "none";
  }

  setupScrollListener() {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.checkScrollPosition();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    this.scrollHandler = handleScroll;
  }

  checkScrollPosition() {
    if (!this.triggerElement) return;

    const triggerRect = this.triggerElement.getBoundingClientRect();
    const shouldShow = triggerRect.bottom < 0;

    if (shouldShow && !this.isVisible) {
      this.show();
    } else if (!shouldShow && this.isVisible) {
      this.hide();
    }
  }

  show() {
    this.isVisible = true;
    this.style.display = "flex";
    this.style.transform = "translateY(0)";
    document.body.classList.add("sticky-bar-visible");
  }

  hide() {
    this.isVisible = false;
    this.style.transform = "translateY(100%)";
    document.body.classList.remove("sticky-bar-visible");

    // Use CSS transition end event instead of setTimeout
    this.addEventListener("transitionend", this.handleTransitionEnd, {
      once: true,
    });
  }

  handleTransitionEnd() {
    if (!this.isVisible) {
      this.style.display = "none";
    }
  }

  removeEventListeners() {
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
    }
  }
}

// Register the custom element
customElements.define("sticky-product-bar", StickyProductBar);
